import { API_BASE } from './config.js';

/**
 * URL affichable pour un chemin public (image voiture/pilote, bibliothèque, upload).
 * - `/assets/...` → origine de l'app (Vite en dev, build client) ;
 * - `/uploads/...` → serveur API.
 */
export function resolveMediaUrl(publicPath: string | null | undefined): string {
  if (!publicPath || publicPath.trim() === '') return '';
  const normalized = publicPath.startsWith('/') ? publicPath : `/${publicPath}`;
  if (normalized.startsWith('/assets/')) return normalized;
  const base = API_BASE.replace(/\/$/, '');
  return `${base}${normalized}`;
}
